const home = {
  heroAlt: "Profesionales revisando planos en una reforma",
  galleryAlt: "Sector construcción y reformas",
  install: {
    iosSub: "Descárgala en el",
    androidSub: "Disponible en",
    iosTitle: "Instalar en iPhone/iPad",
    iosDesc: "Abre esta página en Safari, pulsa Compartir y luego 'Añadir a pantalla de inicio'.",
    androidTitle: "Instalar la app",
    androidDesc: "Abre el menú del navegador y elige 'Instalar app' / 'Añadir a pantalla de inicio'.",
  },
  apps: {
    nuvliTitle: "App móvil NuvliPro",
    nuvliDesc: "Presupuestos, facturas, obras, gastos y control de jornada en tu móvil.",
    nuvliInstall: "Descarga NuvliPro",
    nuvliNote: "Instalación directa (PWA) · funciona en Android e iPhone, sin ocupar espacio.",
    workerTitle: "App móvil Fichaje GPS",
    workerDesc: "Para empleados: fichaje de entrada/salida con GPS e inicio con clave de acceso.",
    workerInstall: "Descarga Fichaje GPS",
    workerNote: "Para trabajadores · tras instalar, abre la app e inicia sesión con tu clave de acceso.",
    workerCta: "Abrir app del trabajador",
    qrTitle: "Control horario con GPS",
    qrSubtitle: "Fichaje fácil y seguro para tu equipo",
    qrText: "Descárgala gratis desde nuestra web",
    qrInstall: "Instalar en el móvil",
    qrAvailable: "Disponible para Android e iPhone",
  },
  login: {
    title: "Iniciar sesión", email: "Email", password: "Contraseña", emailPh: "tu@email.com", submit: "Entrar",
    forgot: "¿Olvidaste tu contraseña?", register: "Regístrate gratis", welcome: "Bienvenido", error: "Error al iniciar sesión",
  },
  features: {
    badge: "Funcionalidades",
    title: "Todo lo que necesitas para gestionar tu negocio",
    items: [
      { t: "Facturación", d: "Facturas con numeración automática, IVA/IRPF, estados y descarga en PDF profesional." },
      { t: "Presupuestos", d: "Presupuestos por capítulos y partidas descriptivas; conviértelos en factura con un clic." },
      { t: "Control de gastos", d: "Registra materiales, mano de obra y suministros; controla el gasto por obra y categoría." },
      { t: "Cobros parciales", d: "Registra abonos, controla el saldo pendiente y envía recibos automáticamente." },
      { t: "Informes trimestrales", d: "IVA e IRPF por trimestre, listos para tu gestoría y exportables en PDF y Excel." },
      { t: "Gestión de clientes", d: "Ficha completa de cada cliente, historial de documentos y detección de morosidad." },
    ],
    presupuestosTexto: "¿Haces presupuestos de obra?",
    presupuestosEnlace: "Mira nuestro programa de presupuestos para reformas",
  },
  pricing: {
    badge: "Planes y precios",
    title: "Elige el plan que mejor se adapta a tu negocio",
    subtitle: "Empieza gratis y sin fecha de fin. Mejora tu plan cuando lo necesites: sin permanencia, cancela cuando quieras.",
    freeCta: "Crear cuenta gratis",
    labels: { gratuito: "Plan Gratuito", trimestral: "Plan Trimestral", anual: "Plan Anual" },
    perMonth: "{{amount}}/mes",
    approx: "≈ {{amount}}/mes",
    periodo: { gratuito: "Sin fecha de fin", trimestral: "{{total}} cada 3 meses", anual: "{{total}} al año" },
    nota: { gratuito: "Para empezar sin pagar", trimestral: "Sin límites, con pago cada 3 meses", anual: "Un solo pago al año" },
    badges: { trimestral: "Más popular" },
    save: "Ahorras {{amount}}/año",
    features: {
      gratuito: ["Hasta 8 clientes", "Hasta 8 presupuestos", "Facturación y cobros parciales para tus 8 clientes", "Gastos y trimestral: los 2 últimos trimestres", "2 proyectos de obra", "Control de fichaje con trabajadores ilimitados"],
      trimestral: ["Clientes, presupuestos y obras sin límite", "Historial completo de gastos y trimestres", "IA, VeriFactu y conciliación bancaria", "Recordatorios por email y WhatsApp", "Exportación para tu gestoría"],
      anual: ["Todo lo del plan Trimestral", "Personalización de documentos y logo", "Avisos automáticos programados", "Soporte prioritario"],
    },
    payCard: "Pagar con tarjeta",
    payNote: "Tarjeta: renovación automática, cancela cuando quieras",
    footnote: "Precios con IVA no incluido · Pago con tarjeta · Pago seguro gestionado por Stripe",
    approxNote: "Equivalencia aproximada en {{currency}} con el tipo de cambio del día. El importe exacto se muestra en la página de pago.",
    payError: "No se pudo iniciar el pago",
  },
  trust: {
    seals: [
      { t: "Cumple RGPD", d: "Datos protegidos" },
      { t: "Cifrado SSL", d: "Conexión segura" },
      { t: "Pagos con Stripe", d: "Cobros protegidos" },
      { t: "Soporte en español", d: "Cuando lo necesites" },
    ],
  },
  demo: {
    badge: "Vídeo demo",
    title: "Descubre NuvliPro en 2 minutos",
    subtitle: "Mira cómo crear un presupuesto, convertirlo en factura y llevar el control de cobros y gastos.",
    unsupported: "Tu navegador no soporta la reproducción de vídeo.",
    soon: "Vídeo demo próximamente",
  },
  faq: {
    badge: "Preguntas frecuentes",
    title: "Resolvemos tus dudas",
    items: [
      { q: "¿Necesito conocimientos de contabilidad para usar NuvliPro?", a: "No. NuvliPro está pensado para autónomos y pequeñas empresas: creas presupuestos y facturas rellenando campos claros, y la app calcula automáticamente IVA, IRPF y totales." },
      { q: "¿Puedo probarlo gratis?", a: "Sí. El Plan Gratuito no caduca y no necesita tarjeta: hasta 8 clientes, 8 presupuestos, 8 facturas y 1 proyecto de obra activo. Cuando necesites más, mejora a un plan de pago." },
      { q: "¿Los datos de mis clientes están seguros?", a: "Sí. Ciframos la conexión (SSL), cumplimos el RGPD y los pagos se gestionan de forma segura con Stripe. Nunca compartimos tus datos." },
      { q: "¿Puedo personalizar mis facturas y presupuestos con mi logo?", a: "Sí. Desde tu Área Personal puedes subir el logo de tu empresa y elegir el diseño del documento para que refleje tu marca." },
      { q: "¿NuvliPro sirve para el control trimestral de impuestos?", a: "Sí. Genera automáticamente el resumen de IVA repercutido/soportado e IRPF por trimestre, exportable en PDF y Excel para tu gestoría." },
      { q: "¿Puedo cancelar cuando quiera?", a: "Por supuesto. No hay permanencia: puedes cambiar o cancelar tu plan en cualquier momento desde tu cuenta." },
    ],
  },
  contact: {
    badge: "Contacto",
    title: "¿Hablamos?",
    subtitle: "Cuéntanos qué necesitas y te responderemos lo antes posible. Estamos aquí para ayudarte a sacar el máximo partido a NuvliPro.",
    support: "Atención al cliente",
    supportNote: "Soporte en español · respuesta en 24-48 h",
    name: "Nombre", namePh: "Tu nombre", email: "Email", emailPh: "tu@email.com",
    message: "Mensaje", messagePh: "¿En qué podemos ayudarte?", send: "Enviar mensaje",
    sent: "¡Mensaje enviado! Te responderemos pronto.", error: "No se pudo enviar el mensaje",
  },
  cta: {
    title: "Todo tu negocio, en un solo lugar",
    items: ["Clientes", "Presupuestos", "Facturación", "Cobros parciales", "Gastos", "Trimestral", "Morosidad", "WhatsApp"],
    button: "Crear mi cuenta gratis",
  },
  footer: "Gestión integral para profesionales de la construcción y reformas",
};
export default home;
